"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormHelperText = exports.Required = exports.Label = exports.Input = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const styled_components_1 = __importStar(require("styled-components"));
exports.Input = (0, styled_components_1.default)(({ className, ...props }) => ((0, jsx_runtime_1.jsx)(material_1.TextField, { classes: { root: className }, ...props })))(({ $isError, $isValue, $isClickable, $smallPlaceholderFontSize, $mediumPlaceholderFontSize, $isDisabled, variant, theme: { palette, shape }, }) => (0, styled_components_1.css) `
    & .MuiFilledInput-root {
      background-color: ${palette.grey[100]};
      color: ${$isError ? palette.error.main : palette.text.primary};
      border-radius: ${shape.borderRadius}px;
      font-weight: 700;

      &::before {
        content: none;
      }

      input[type='password'] {
        font-family: Verdana;
        letter-spacing: 4px;
      }

      input[type='number'] {
        -webkit-appearance: none;
        -moz-appearance: textfield;
      }
    }

    & .MuiFilledInput-input.MuiInputBase-inputSizeSmall {
      padding-top: ${$isValue && !$isError && '12.5px'};
      padding-bottom: ${$isValue && !$isError && '12.5px'};
    }

    & .MuiInputBase-multiline {
      padding-top: ${$isValue && 0};
      padding-bottom: ${$isValue && 0};
      padding-top: ${$isError && '23px'};
      padding-bottom: ${$isError && '2px'};
    }

    & .MuiFilledInput-root.Mui-focused {
      background-color: ${palette.grey[200]};
    }

    & .MuiFilledInput-underline:before {
      border-bottom: none;
    }

    & .MuiFilledInput-underline:after {
      border-bottom: none;
    }

    &::placeholder {
      font-size: 14px;
    }

    & .MuiFormLabel-root {
      color: ${$isError ? palette.error.main : palette.text.primary};
      font-weight: 500;
      top: ${variant === 'outlined' && '5px'};
      font-size: ${$smallPlaceholderFontSize && '13px'} !important;
      font-size: ${$mediumPlaceholderFontSize && '14px'} !important;
      opacity: ${$isDisabled ? 0.5 : 1} !important;
    }

    & .css-154xyx0-MuiInputBase-root-MuiOutlinedInput-root {
      border-radius: ${shape.borderRadius}px;
    }

    & .MuiOutlinedInput-input {
      padding: 13.5px 16px;
      font-weight: 700;
    }

    & .css-1i7e0ou-MuiFormLabel-root-MuiInputLabel-root {
      transform: translate(14.5px, 16px) scale(1);
    }

    & .css-1ihe0i9-MuiInputBase-root-MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline {
      border-color: ${palette.grey[400]};
    }

    & .Mui-disabled {
      cursor: ${$isClickable ? 'pointer' : 'not-allowed'};
      opacity: ${$isClickable ? 1 : 0.6};
    }

    & .MuiFilledInput-input.Mui-disabled {
      color: ${palette.text.primary};
      -webkit-text-fill-color: ${palette.text.primary};
      opacity: ${$isClickable ? 1 : 0.6};
    }

    & input[type='number']::-webkit-inner-spin-button,
    input[type='number']::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  `);
exports.Label = (0, styled_components_1.default)(material_1.InputLabel) `
  margin-bottom: 8px;
  font-weight: 700;
`;
exports.Required = styled_components_1.default.span(({ theme: { palette } }) => `
  color: ${palette.error.main};
`);
exports.FormHelperText = (0, styled_components_1.default)(material_1.FormHelperText)(({ $isHelperText, $isError, theme: { palette } }) => (0, styled_components_1.css) `
    display: block;
    font-weight: 700;
    color: ${palette.error.main};
    color: ${$isHelperText && !$isError && palette.grey[800]};
  `);
